import { AnyAction } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { RootState } from "./Store";

export const useAppDispatch = () => useDispatch<ThunkDispatch<RootState, undefined, AnyAction>>();
